
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"58","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33.649 2.2c-2.77 1.466-4.86 3.548-6.274 6.244-1.413 2.697-2.12 5.882-2.12 9.556v.043c-.005 3.923-.986 6.917-2.943 8.982-1.961 2.073-4.754 3.11-8.37 3.11h-6.97V5.864h6.97c3.616 0 6.409 1.036 8.37 3.11.794.836 1.423 1.825 1.895 2.965.49-2.757 1.327-5.271 2.514-7.542.058-.104.11-.206.168-.309a15.619 15.619 0 00-2.793-1.89C21.322.733 17.971 0 14.048 0H0v36h14.048c3.923 0 7.274-.733 10.048-2.2 2.77-1.466 4.86-3.547 6.274-6.244 1.409-2.686 2.11-5.857 2.116-9.513h.004V18c0-3.944.981-6.953 2.943-9.026 1.961-2.073 4.75-3.11 8.365-3.11h6.976v24.27h-6.976c-3.615 0-6.404-1.036-8.365-3.109a9.584 9.584 0 01-1.9-2.97c-.485 2.793-1.326 5.337-2.528 7.633a5.545 5.545 0 01-.135.246A15.59 15.59 0 0033.65 33.8c2.774 1.467 6.125 2.2 10.048 2.2h14.048V0H43.697c-3.923 0-7.274.733-10.048 2.2z","fill":"#000F40"}})])
          )
        }
      }
    